import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bolt, MapPin, Coins, GraduationCap, TrendingUp, Battery, Bike, Zap, Wrench, Home as HomeIcon } from 'lucide-react';
import { useSection } from '../../hooks/useSection';

const ICONS: Record<string, React.ComponentType<any>> = { Bolt, MapPin, Coins, GraduationCap, TrendingUp, Battery, Bike, Zap, Wrench, Home: HomeIcon };

const DEFAULT_ITEMS = [
  { label: 'Motos', icon: 'Bolt', to: '/products' },
  { label: 'Stations', icon: 'MapPin', to: '/stations' },
  { label: 'Financement', icon: 'Coins', to: '/pay-as-you-go' },
  { label: 'Académie', icon: 'GraduationCap', to: '/training' },
];

const QuickNav: React.FC = () => {
  const { pathname } = useLocation();
  const { section } = useSection('home_quicknav');
  if (section && section.is_visible === false) return null;
  const items = (section?.extra_data?.items?.length ? section.extra_data.items : DEFAULT_ITEMS) as Array<{ label: string; icon?: string; to: string }>;

  return (
    <section aria-label="Navigation rapide" className="md:hidden border-b border-neutral-100 bg-white">
      <div className="container mx-auto">
        <div
          className="flex justify-center gap-2.5 overflow-x-auto py-2 px-1 scrollbar-hide"
          style={{ scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch' }}
        >
          {items.map((item, r) => {
            const Icon = (item.icon && ICONS[item.icon]) || Bolt;
            const active = pathname === '/' ? r === 0 : (item.to !== '/' && pathname.startsWith(item.to));
            return (
              <Link
                key={r}
                to={item.to}
                className="flex shrink-0 flex-col items-center gap-1 active:scale-95 transition-transform duration-200"
                style={{ scrollSnapAlign: 'start' }}
                aria-label={`Aller à ${item.label}`}
              >
                <div className={`flex h-11 w-11 items-center justify-center rounded-full p-0.5 ${active ? 'bg-primary-500' : 'bg-transparent ring-2 ring-neutral-200'}`}>
                  <div className="flex h-full w-full items-center justify-center rounded-full bg-white">
                    <Icon className={active ? 'text-primary-600' : 'text-neutral-700'} size={18} strokeWidth={2.2} aria-hidden="true" />
                  </div>
                </div>
                <span className={`text-[10px] font-bold ${active ? 'text-neutral-900' : 'text-neutral-500'}`}>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickNav;
